import { EntityRelationsGraph } from './EntityRelationsGraph';
import {
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
} from '@backstage/catalog-model';
import { entityUtil } from '@appfolio/backstage-plugin-catalog-common';
import { ANNOTATION_PACKAGE_TYPE } from '@appfolio/backstage-plugin-catalog-common';
import { useGemEntityRefOptions as useGemEntityRefOptions } from '../../hooks/useGemEntityRefOptions';

export const GemDependencyGraph = () => {
  const { options } = useGemEntityRefOptions();
  return (
    <EntityRelationsGraph
      title="Gem Dependencies"
      options={options}
      entityFilter={entity => {
        const e = entityUtil(entity);
        return e.isAnnotatedWith(ANNOTATION_PACKAGE_TYPE, 'gem');
      }}
      relations={[RELATION_DEPENDS_ON, RELATION_DEPENDENCY_OF]}
    />
  );
};
